import { replayTerminals } from "../playback/replay-timing";
import type { ReplayLaunch } from "./replay-session-records";

const staticManifestHash = /\/replays\/static\/[^/]+\/([^/]+)\//;
const percentEncoded = /^(?:[^%]|%[0-9A-Fa-f]{2})*$/;
export function replayLaunchTiming(created: ReplayLaunch): Readonly<{
  delivery: "static_bundle" | "static" | "runtime";
  viewerManifestHash: string | null;
  responseReceivedAt: number;
  sessionShared: boolean;
}> {
  const viewerPath = new URL(created.viewer_url).pathname;
  const delivery = created.ready
    ? viewerPath.endsWith("/index.html")
      ? "static_bundle"
      : "static"
    : "runtime";
  const manifestHash = staticManifestHash.exec(viewerPath)?.[1];
  const viewerManifestHash =
    manifestHash !== undefined && percentEncoded.test(manifestHash)
      ? decodeURIComponent(manifestHash)
      : null;
  return {
    delivery,
    viewerManifestHash,
    responseReceivedAt: created.responseReceivedAt,
    sessionShared: created.sessionShared,
  };
}

export function replayReadinessFailure(error: Error): Readonly<{
  terminal:
    | typeof replayTerminals.runtimeError
    | typeof replayTerminals.runtimeTimeout;
  message: string;
}> {
  if (error.name === "TimeoutError") {
    return {
      terminal: replayTerminals.runtimeTimeout,
      message:
        "Replay timed out while starting — the replay server could not load this recording. Try again later.",
    };
  }

  return { terminal: replayTerminals.runtimeError, message: error.message };
}
